"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleCancelCheckoutView = void 0;
var lodash_1 = require("lodash");
var handleCancelCheckoutView = function (mutation, state) {
    try {
        var productsForTracking = state.planning.shop.productsForTracking || [];
        var products_1 = [];
        productsForTracking.forEach(function (article) {
            products_1.push({
                dimension32: 'OBR',
                id: article.id,
                quantity: article.quantity,
            });
        });
        var agencyId = (0, lodash_1.get)(state, 'planning.shop.agencyData.number', '');
        var events = [
            {
                event: 'EECrefund',
                ecommerce: {
                    dimension67: agencyId,
                    refund: {
                        actionField: {
                            id: state.planning.shop.lastCancelCheckoutNumber,
                        },
                        products: products_1,
                    },
                },
            },
        ];
        return events;
    }
    catch (error) {
        console.error(error);
    }
    return [];
};
exports.handleCancelCheckoutView = handleCancelCheckoutView;
//# sourceMappingURL=cancel_checkout.js.map